import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';

import {
  formatMiscPurchaseOrderStatusLabel,
} from '../helper/miscPurchaseOrderStatus';

const MiscPurchaseOrderStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatMiscPurchaseOrderStatusLabel(status)}
    size={size}
    className={className}
  />
);

MiscPurchaseOrderStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default MiscPurchaseOrderStatusBadge;
